// Map any US state/territory/military code or name to its full name for QuickBase. QuickBase must
// always receive the full state name ("California"), never the 2-letter abbreviation ("CA") that
// the UI dropdown and the address providers (USPS/Google/Census) use.
const ABBR_TO_NAME = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia',
  FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois',
  IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana',
  ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota',
  MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada',
  NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York',
  NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon',
  PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota',
  TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia',
  WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
  AS: 'American Samoa', GU: 'Guam', MP: 'Northern Mariana Islands', PR: 'Puerto Rico',
  VI: 'U.S. Virgin Islands', AA: 'Armed Forces Americas', AE: 'Armed Forces Europe',
  AP: 'Armed Forces Pacific',
};

const NAME_BY_LOWER = Object.values(ABBR_TO_NAME).reduce((acc, name) => {
  acc[name.toLowerCase()] = name;
  return acc;
}, {});

const ABBR_BY_NAME = Object.entries(ABBR_TO_NAME).reduce((acc, [abbr, name]) => {
  acc[name.toLowerCase()] = abbr;
  return acc;
}, {});

// Return the full state name for a 2-letter abbreviation or an already-full name. Case-insensitive
// and idempotent; unknown or empty input is returned trimmed and otherwise unchanged.
export function fullStateName(state) {
  const trimmed = (state || '').toString().trim();
  if (!trimmed) return trimmed;
  const byAbbr = ABBR_TO_NAME[trimmed.toUpperCase()];
  if (byAbbr) return byAbbr;
  const byName = NAME_BY_LOWER[trimmed.toLowerCase()];
  if (byName) return byName;
  return trimmed;
}

// Return the uppercase 2-letter code for a full name or an already-abbreviated code. This is what
// USPS (and the geocoders) expect. Case-insensitive and idempotent; unknown or empty input is
// returned trimmed and otherwise unchanged.
export function abbreviateState(state) {
  const trimmed = (state || '').toString().trim();
  if (!trimmed) return trimmed;
  if (ABBR_TO_NAME[trimmed.toUpperCase()]) return trimmed.toUpperCase();
  const byName = ABBR_BY_NAME[trimmed.toLowerCase()];
  if (byName) return byName;
  return trimmed;
}
